import { useEffect, useState } from "react";

import { updateContactSettings } from "../../services/settingsApi";

function ContactSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        supportEmail: "",
        supportPhone: "",
        officeAddress: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                supportEmail: settings.supportEmail || "",
                supportPhone: settings.supportPhone || "",
                officeAddress: settings.officeAddress || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateContactSettings(formData);

            alert("Contact settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update contact settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Contact Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Support Email</label>

                        <input
                            type="email"
                            name="supportEmail"
                            value={formData.supportEmail}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Support Phone</label>

                        <input
                            type="text"
                            name="supportPhone"
                            value={formData.supportPhone}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Office Address</label>

                        <textarea
                            name="officeAddress"
                            rows="4"
                            value={formData.officeAddress}
                            onChange={handleChange}
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Contact Settings
                </button>

            </div>

        </form>

    );

}

export default ContactSettings;